import * as XLSX from 'xlsx';
import Url from '../global/Url';

/** Opciones para los dropdowns de filtros. */
export async function getOpciones() {
    const resp = await fetch(Url.Api + 'reporte/opciones', { credentials: 'same-origin' });
    const data = await resp.json();
    if (!resp.ok || data.header !== 'OK') throw new Error(data.message || 'No se pudieron cargar las opciones');
    return data;
}

/** Ejecuta el reporte con los filtros dados. */
export async function getReporte(filtros) {
    const qs = new URLSearchParams();
    Object.entries(filtros).forEach(([k, v]) => { if (v !== '' && v != null) qs.append(k, v); });
    const resp = await fetch(Url.Api + 'reporte/asignaciones?' + qs.toString(), { credentials: 'same-origin' });
    const data = await resp.json();
    if (!resp.ok || data.header !== 'OK') throw new Error(data.message || 'Error al generar el reporte');
    return data;
}

/** Exporta las filas a Excel con los mismos encabezados de la tabla. */
export function exportarExcel(rows) {
    const cols = [
        ['numero', 'Número'], ['fecha', 'Fecha'], ['hora', 'Hora'],
        ['asignador', 'Asignador'], ['asesora', 'Asesora'],
        ['campania', 'Campaña'], ['estado', 'Estado'],
        ['venta_real', 'Venta real (Activa)'], ['tipo', 'Tipo'],
    ];
    const matriz = [cols.map((c) => c[1])];
    for (const r of rows) matriz.push(cols.map((c) => r[c[0]] ?? ''));
    const ws = XLSX.utils.aoa_to_sheet(matriz);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Asignaciones');
    const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    XLSX.writeFile(wb, `reporte-asignaciones-${stamp}.xlsx`);
}

/** Cuenta ocurrencias de un campo en las filas (para los desgloses). */
export function agrupar(rows, campo) {
    const m = {};
    for (const r of rows) { const k = r[campo] || '(sin dato)'; m[k] = (m[k] || 0) + 1; }
    return Object.entries(m).sort((a, b) => b[1] - a[1]);
}
